(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rfReviewsBound) return;
    window.__rfReviewsBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href="#reviews"]');
      var section = document.querySelector('[data-rf-reviews]');
      if (!link || !section) return;
      event.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
